import React from 'react';
import { AnaliseGrauExposicaoRisco } from '@/types/analise/AnaliseGrauExposicaoRisco';
import {
  GRAU_EXPOSICAO_RISCO_CORES,
  GRAU_EXPOSICAO_RISCO_NOMES,
} from '@/constants/grau-exposicao-risco/GrauExposicaoRisco';

const MATRIZ_ITEMS: AnaliseGrauExposicaoRisco[][] = [
  ['ELEVADO', 'CRITICO', 'CRITICO', 'CRITICO'],
  ['MODERADO', 'ELEVADO', 'CRITICO', 'CRITICO'],
  ['BAIXO', 'MODERADO', 'ELEVADO', 'ELEVADO'],
  ['INEXPRESSIVO', 'MODERADO', 'ELEVADO', 'ELEVADO'],
];
const MATRIZ_X_AXIS_TITLE = 'IMPACTO';
const MATRIZ_Y_AXIS_TITLE = 'PRIORIDADE';
const MATRIZ_X_AXIS_LABELS = ['Baixo', 'Médio', 'Alto', 'Crítico'];
const MATRIZ_Y_AXIS_LABELS = ['Crítica', 'Alta', 'Média', 'Baixa'];

export function MatrizGrauExposicaoRisco() {
  return (
    <div className="flex">
      <div className="flex items-center">
        <span className="rotate-180 px-1 text-xs text-agnes-text-muted [writing-mode:vertical-rl]">
          {MATRIZ_Y_AXIS_TITLE}
        </span>
      </div>

      <div className="flex-1">
        <div className="grid grid-cols-[64px_repeat(4,1fr)] gap-1 text-xs text-white">
          {MATRIZ_ITEMS.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <div className="flex items-center justify-center text-agnes-text-muted">
                {MATRIZ_Y_AXIS_LABELS[rowIndex]}
              </div>

              {row.map((cell, cellIndex) => (
                <div
                  key={cellIndex}
                  className="flex flex-col items-center justify-center rounded py-4"
                  style={{ background: GRAU_EXPOSICAO_RISCO_CORES[cell] }}
                >
                  <span className="font-semibold">{GRAU_EXPOSICAO_RISCO_NOMES[cell]}</span>
                </div>
              ))}
            </React.Fragment>
          ))}
          <div />

          {MATRIZ_X_AXIS_LABELS.map((label) => (
            <div key={label} className="pt-1 text-center text-agnes-text-muted">
              {label}
            </div>
          ))}
        </div>

        <p className="mt-1 text-center text-xs font-medium text-agnes-text-muted">
          {MATRIZ_X_AXIS_TITLE}
        </p>
      </div>
    </div>
  );
}
